import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert, getConfig } from 'utils'

export const superAdminDashboardStats = createAsyncThunk(
    'superAdminDashboard/stats',
    async ({ navigate }) => {
        try {
            const res = await axios({
                method: 'GET',
                url: getConfig.API_URL + 'super_admin_dashboard',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: SessionManager.getCookie('user_token'),
                },
            })
            return res
        } catch (error) {
            return error.response
        }
    },
)

const superAdminDashboardSlice = createSlice({
    name: 'superAdminDashboard',
    initialState: {
        data: null,
        loading: false,
    },
    reducers: {
        clearSuperAdminDashboard: (state) => {
            state.data = null
        },
    },
    extraReducers: (builder) => {
        builder.addCase(superAdminDashboardStats.pending, (state) => {
            state.loading = true
        })
        builder.addCase(superAdminDashboardStats.fulfilled, (state, action) => {
            state.loading = false
            const payload = action.payload

            if (payload?.status === 401) {
                showTokenExpiredAlert(payload?.data?.message, action.meta.arg.navigate)
                state.data = null
                return
            }
            if (payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
                state.data = null
                return
            }

            if (payload?.status === 200) {
                state.data = payload.data?.data || null
            } else {
                state.data = null
            }
        })
        builder.addCase(superAdminDashboardStats.rejected, (state) => {
            state.loading = false
            state.data = null
        })
    },
})

export const { clearSuperAdminDashboard } = superAdminDashboardSlice.actions
export default superAdminDashboardSlice.reducer
